import store from '@/store'


export const clearAtencionLS = () => {
  
  localStorage.removeItem('crearAnamnesis');
  localStorage.removeItem('atencionReceta');
  localStorage.removeItem('atencionImagenes');
  localStorage.removeItem('atencionLaboratorios');
  localStorage.removeItem('atencionTerapias');
  localStorage.removeItem('atencionProcesos');
  localStorage.removeItem('descanso');
  localStorage.removeItem('infoCitaPush');
  localStorage.removeItem('laboratorioitems')
}



export const clearAtencionState = () => {

  store.commit("resetAnamnesis");
  store.commit("resetImagenes");
  store.commit("resetTerapias");
  store.commit("resetDescanso");
  store.commit("resetReceta");

  store.commit("resetSubidoEncuesta");
  store.commit("resetDocAs400");

  store.commit("resetAtencionCita");
  store.commit("resetDerivacionesInterconsultas");

  store.dispatch('resetSemiologias');
}


export const clearDataAtencion = () => {
  clearAtencionLS();
  clearAtencionState();
}

